import { Injectable } from '@angular/core';
import { ManPowerService } from '@ups/xplat/api/manpower';
import { ApplicationModel } from '@ups/xplat/api/dto';

@Injectable({
  providedIn: 'root',
})
export class BackgroundStatusResolver {
  constructor(
    private manPowerService: ManPowerService,
    private applicationModel: ApplicationModel
  ) {}

  public load(): Promise<unknown> {
    if (this.applicationModel.backgroundStatuses.length === 0) {
      return this.manPowerService
        .fetchBackgroundStatuses()
        .then((data) => (this.applicationModel.backgroundStatuses = data));
    }

    return Promise.resolve(this.applicationModel.backgroundStatuses);
  }
}
